import { render, staticRenderFns } from "./PriceOfferFields.vue?vue&type=template&id=f056d2b0&"
import script from "./PriceOfferFields.vue?vue&type=script&lang=js&"
export * from "./PriceOfferFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports